import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
} from 'store/helpers/filterHelpers';
import { copyNewsFiltersInitialState } from './initialState/copyNewsInitialState';

export const copyNewsContentInitialState = {
  filters: copyNewsFiltersInitialState,
};

export const copyNewsContentSlice = createSlice({
  name: 'copyNewsContentSlice',
  initialState: copyNewsContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, copyNewsFiltersInitialState);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = copyNewsFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, copyNewsFiltersInitialState);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedContentBasedValues,
  setSelectedFilter,
} = copyNewsContentSlice.actions;
